import React, { useEffect, useState, useRef } from 'react';
import './header_busq.css'
import { useTranslation } from 'react-i18next';

import lupa from '../../../assets/img/lupa.png';

const Header_busq = ({ titulo, blogs, ideas, libros }) => {
    const [t, i18n] = useTranslation("busqueda");
    const [inputVal, setInputVal] = useState('');
    const handleInputChange = (event) => {
        setInputVal(event.target.value);
    };
    const handleClick = () => {

        window.location.href = "/"+i18n.language+"/busqueda/" + inputVal;
    };

    const renderizarlinks = () => {
        var htmllinks = "";
        if (blogs === 0) {
            htmllinks = '<a class="noh">0 ' + (t('header.res1')) + '</a>';
        }
        else {
            if (blogs === 1) {
                htmllinks = '<a href="#bus_blogs" class="sih">1 ' + (t('header.res1_1')) + '</a>';
            }
            else {
                htmllinks = '<a href="#bus_blogs" class="sih">' + blogs + ' ' + (t('header.res1')) + '</a>';
            }

        }

        if (ideas === 0) {
            htmllinks = htmllinks + '<a class="noh">0 ' + (t('header.res2')) + '</a>';
        }
        else {
            if (ideas === 1) {
                htmllinks = htmllinks + '<a href="#bus_ideas" class="sih">1 ' + (t('header.res2_1')) + '</a>';
            }
            else {
                htmllinks = htmllinks + '<a href="#bus_ideas" class="sih">' + ideas + ' ' + (t('header.res2')) + '</a>';
            }
        }

        if (libros === 0) {
            htmllinks = htmllinks + '<a class="noh">0 ' + (t('header.res3')) + '</a>';
        }
        else {
            if (libros === 1) {
                htmllinks = htmllinks + '<a href="#bus_libros" class="sih">1 ' + (t('header.res3_1')) + '</a>';
            }
            else {
                htmllinks = htmllinks + '<a href="#bus_libros" class="sih">' + libros + ' ' + (t('header.res3')) + '</a>';
            }
        }

        return <div className='rest_res' dangerouslySetInnerHTML={{ __html: htmllinks }} />;
    };

    const handleKeyDown = (e) => {
        // Verificar si la tecla presionada es "Enter" (código 13)
        if (e.key === 'Enter') {
            handleClick();
        }
    };

    const clearSearch = () => {
        setInputVal('');
    };

    return (
        <div class="_ngcontent-ng-c2327341559 _nghost-ng-c3032922633">
            <header class="biblioteca-header header-busqueda-g">
                <div class="biblioteca-header__inner">
                    <h1 class="biblioteca-header__title">{t("header.resultadosN")} "{titulo}"</h1>
                    <div aria-label="Controles de biblioteca"
                        class="biblioteca-header__controls">
                        <div
                            class="biblioteca-header__control biblioteca-header__control--search">
                            <label>
                                <span class="biblioteca-header__visually-hidden">{t("header.search")}</span>
                                <input type="search" placeholder={t("header.search")}
                                    value={inputVal}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown} />
                                {inputVal && (
                                    <button
                                        onClick={clearSearch}
                                        className='btn-srch-inpt2'
                                    >
                                        &#x2715; {/* Esto es el símbolo de "X" */}
                                    </button>
                                )}
                                <button type="button" aria-label="Buscar" onClick={handleClick} class="biblioteca-header__search-button">
                                    <img src="/assets/img2026/logo_search.svg" alt="Buscar" aria-hidden="true" />
                                </button>
                            </label>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );

}

export default Header_busq;